const styles = theme => ({
  headerTop: {
    height: 80,
    display: "flex",
    flexWrap: "wrap"
  },
  headerTopLeft: {
    display: "flex",
    alignItems: "center",
    width: 300,
    height: "100%"
  },
  logo: {
    height: 60
  },

  headerContact: {
    position: 'relative',
    "& .show": {
      display: 'block'
    },

    "& .hidden": {
      display: 'none'
    },

    "& ul": {
      top: 65,
      position: 'absolute',
      border: "1px solid #e1e1e1",
      zIndex: 11, 
      backgroundColor: "white",
      width: "calc(100% + 31px)",
      borderRadius: 2,
      boxShadow: "0px 3px 6px rgba(0, 0, 0, .2)",
       
    },

    "& ul li": {
      padding: 5,
      borderBottom: "1px solid #e1e1e1",
    },

    "& ul li img": {
      width: 25,
      marginRight: 10
    },

    "& ul li a": {
      fontSize: 14,
      fontWeight: 600,
      padding: "5px 5px",
      display: 'flex',
      alignItems: 'center',
    }
  },

  headerTopRight: {
    width: "calc(100% - 300px)",
    position: "relative",
    padding: "0 30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    "& > div": {
      display: "flex",
      alignItems: "center",

      "& .header-top-icon": {
        fontSize: 36,
        marginRight: 10,
        color: theme.colors.primary
      },

      "& h5": {
        color: "#555"
      },

      "& h3": {
      },

      "& h3 a": {
        fontWeight: 600,

        "&:hover": {
          color: theme.colors.primary
        }
      },

      "& h3 svg": {
        top: 10,
        position: 'absolute',
      },
    }
  },
  headerBottom: {
    height: 60,
    background: theme.colors.primary,
    color: "white",

    "& .container": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between"
    }
  },
  logoMobile: {
    display: 'none'
  },
  menu: {
    height: 60,

    "& ul": {
      display: "flex",
      alignItems: "center",
      height: "100%",

      "& li": {
        position: "relative",

        "& a": {
          fontSize: 16,
          fontWeight: 600,
          padding: "19px 20px",
          display: "flex",
          alignItems: "center",
          textTransform: "uppercase",

          "&:hover": {
            color: "black"
          },

          "& svg": {
            marginLeft: 10
          },

          "&.active": {
            color: "black"
          }
        },

        "&:first-child a": {
          paddingLeft: 0
        },

        "& ul": {
          position: "absolute",
          width: 300,
          background: "white",
          zIndex: 10,
          left: 0,
          top: 60,
          display: "block",
          transform: "translateY(-50%) scaleY(0)",
          opacity: 0,
          transition: ".3s",
          visibility: "hidden",
          border: "1px solid #e1e1e1",
          boxShadow: "0 3px 6px rgba(0, 0, 0, .2)",
          height: "auto",

          "& li": {
            width: "100%",
            overflow: "hidden",
            position: "relative",

            "&:before": {
              content: "attr(href)",
              background: theme.colors.primary,
              width: "50%",
              height: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              transition: ".5s",
              transform: "translateX(-100%)"
            },
            "&:after": {
              content: "attr(href)",
              background: theme.colors.primary,
              width: "50%",
              height: "100%",
              position: "absolute",
              top: 0,
              right: 0,
              transition: ".5s",
              transform: "translateX(100%)"
            },

            "& a": {
              color: "black",
              padding: "12px 15px",
              fontSize: 14,
              fontWeight: 500,
              textTransform: "initial",
              borderBottom: "1px solid #e1e1e1",
              position: "relative",
              zIndex: 1,
              transition: ".5s"
            },

            "&:hover": {
              "& a": {
                color: "white"
              },

              "&:before, &:after": {
                transform: "none"
              }
            },

            "&:first-child a": {
              paddingLeft: 15
            }
          }
        },

        "&:hover ul": {
          transform: "none",
          visibility: "initial",
          opacity: 1,
        }
      }
    }
  },
  headerBottomRight: {
    height: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",

    "& input": {
      height: 40,
      width: 250,
      border: 0,
      paddingLeft: 10,
      paddingRight: 40,
      borderRadius: 3,

      "&:focus": {
        outline: "none"
      }
    },

    "& form": {
      position: "relative"
    },

    "& button": {
      background: "none",
      border: 0,
      position: "absolute",
      right: 8,
      top: 8,
      cursor: "pointer",

      "&:focus": {
        outline: "none"
      }
    },

    "& svg": {
      fontSize: 24,
      color: "black",
      transition: ".3s",

      "&:hover": {
        color: theme.colors.primary
      }
    },
  },

  searchButton: {
    display: "none"
  },
  

  [theme.breakpoints.down('xl')]: {
  },

  [theme.breakpoints.down('lg')]: {
    headerTopLeft: {
      height: '100%',
      maxWidth: '15vw',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      
      "& img": {
        height: "auto !important"
      },
    },
    headerTopRight: {
      width: "calc(100% - 200px)"
    },
    headerBottomRight: {
      width: '20vw',
      "& input": {
        width: "200px"
      }
    },
    menu: {
      "& ul li ul":{
        top: 58
      },

      "& ul li a": {
        fontSize: '0.9em'
      }
    },
  },
  [theme.breakpoints.down('md')]: {
    headerBottom: {
      height: '50px', 
      justifyContent: 'space-around',
    },

    headerContact: {
      "& ul": {
        top: 57
      }
    },

    menu: {
      height: '50px', 
      "& ul li a": {
        fontSize: '0.9em'
      },
      "& ul": {
        width: "100%",
        display: "flex",
        justifyContent: "center"
      },

      "& ul li ul":{
        top: 53
      },

      width: "85vw" 
    },

    headerTop: {
      paddingLeft: "5px",
      paddingRight: "5px"
    },

    headerTopLeft: {
      maxWidth: '20vw',
    },

    headerTopRight: {
      fontSize: '0.7em',
      width: '75vw',
    },

    headerBottomRight: {
      height: "50px",
      width: "5vw",
      margin: "0 !important",
      "& input": {
        height: "30px",
        width: "20vw",
      },
      
      "& button": {
        top: 0,
        right: 0
      },

      "& form button": {
        top: 8,
        right: 8
      },

      "& svg": {
        fontSize: "1em"
      },
      position: "relative"
    },

    searchHeader: {
      position: 'absolute',
      top: "52px",
      right: 10,
      zIndex: "10",
      border: "1px solid #2ac17f",
      display: "none",
      borderRadius: "3px",
      "&.active":{
        display: "block"
      }
    },

    searchButton: {
      display: "block",
      height: "30px",
      width: "30px",
      backgroundColor: "black",
      borderRadius: "50%",
      position: "relative",
      left: "-15%",
      "& button": {
        position: 'absolute',
        fontSize: "1.3em",
        width: '100%',
        height: '100%'
      },
      "& button svg": {
        position: 'absolute',
        color: "red",
        fontWeight: "bold",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width:'50%'
      },

      "& button svg:hover": {
        color: "white",
        fontWeight: "bold"
      }
    },

    arrowUp: {
      width: "0", 
      height: "0", 
      borderLeft: "5px solid transparent",
      borderRight: "5px solid transparent",      
      borderBottom: `10px solid white`,
      position: "absolute",
      top: "-10px",
      right: 5,
    }
  },

  [theme.breakpoints.down('sm')]: {
    headerTop: {
      height: "auto",
      paddingBottom: "10px",
      display: "inline-block",
    },

    headerContact: {
      "& ul": {
        top: 47
      }
    },

    headerTopLeft: {
      margin: "auto",
      width: "100%",
      display: 'none'
    },
    headerBottomRight: {
      position: 'absolute',
      right: 0,
      width: 50,

      "& input": {
        width: "calc(100vw - 20px)",
        height: "35px",
      },
      "& svg": {
        marginTop: "2px",
      },

      "& button": {
        top: -2,
        right: 0
      },
    },
    headerTopRight: {
      width: "100%",
      marginTop: 60,
      boxShadow: "0 3px 6px rgba(0, 0, 0, .2)",
      paddingBottom: 10,
    },
    // menu reponsive
    headerBottom: {
      position: 'fixed',
      top: 0,
      right: 0,
      left: 0,
      zIndex: 100,
      background: 'white',
      boxShadow: '0 3px 6px rgba(0, 0, 0, .2)'
    },
    
    sidebarBtn: {
      position: 'absolute',
      top: 10,
      left: 10,
      background: "#fff",
      height: 30,
      width: 30,
      borderRadius: 3,
      border: 0,

      '& span': {
        display: "block",
        width: "20px",
        height: "2px",
        backgroundColor: "black",
        position: "absolute",
        top: 14,
        left: 5,
        transition: ".3s",

        '&:before, &:after': {
          content: "attr(href)",
          position: 'absolute',
          width: "20px",
          height: "2px",
          backgroundColor: "black",
          transition: ".3s",
          left: 0
        },
        '&:before': {
          top: -5
        },
        '&:after': {
          top: 5
        }
      },
    },
    menu: {
      height: "100%",
      zIndex: 102,
      transition: "0.5s",
      paddingTop: "60px",
      position: 'absolute',
      top: 0,
      left: 0,
      width: 50,

      "& ul": {
        position: 'absolute',
        top: 0,
        left: 0,
        flexDirection: 'column',
        width: 250,
        transition: '.3s',
        transform: 'translateX(-250px)',
        zIndex: 103,
        background: 'black',
        height: '100vh',
        justifyContent: 'flex-start',

        '&.mobile-active': {
          transform: 'none'
        },

        "& li": {
          listStyle: "none",
          width: '100%',
          marginTop: 0,

          '&:first-child a': {
            padding: '10px 20px',
            marginTop: 0
          },

          '& a': {
            color: 'white',
            borderBottom: '1px solid #111',
            padding: '15px 20px'
          },

          '& a.active': {
            color: theme.colors.primary
          },

          '& ul': {
            width: 250,
          },

          '&:hover ul': {
            opacity: 0,
            transform: 'translateY(-50%) scaleY(0)',
            visibility: 'hidden'
          }, 

          '& ul.show-child': {
            top: 0,
            position: 'relative',
            opacity: 1,
            transform: 'none',
            visibility: 'initial'
          }
        },
      },
      "& ul li a": {
        padding: "10px 20px",
        color: "red",
        display: "block",
        borderBottom: "1px solid rgba(0,0,0,0.2)",
      },
         
    },
    overlayMenu: {
      position: 'fixed',
      zIndex: 102,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0, 0, 0, .6)',
      top: 0,
      left: 0
    },
    active: {
      left: "0"
    },

    logoMobile: {
      display: 'block',
      position: 'fixed',
      top: 10,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 101,
      height: 30
    },

    [theme.breakpoints.down('xs')]: {
      headerTopLeft: {
        maxWidth: 'auto',
      },

      headerTopRight: {
        display: 'block',
      },

      headerContact: {
        width: "100%",
        padding: "5px",

        "& ul": {
          top: 57, 
          width: "100%",
        }
      },

    },
  },
});

export default styles;
